import ls from 'localstorage-slim'
import { format } from 'date-fns'
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz'
import ptBR from 'date-fns/locale/pt-BR'
import en from 'date-fns/locale/en-US'
import es from 'date-fns/locale/es'

// locale
const locales = {
  pt: ptBR,
  en,
  es
}

// detect language from localstorage
const language =
  ls.get<keyof typeof locales>('@CLINIC:LANGUAGE_DEFAULT') || 'pt'

// get locale
const locale = locales[language]

// timezone to datetime input format
export const toDateTimeInput = (
  utcDate: string | Date,
  timeZone: string
): string => {
  if (!utcDate) return ''

  const zonedDate = utcToZonedTime(utcDate, timeZone)

  return format(zonedDate, 'yyyy-MM-dd HH:mm', { locale: locale })
}

/**
 * Formata data UTC para dd/MM/yyyy no timezone da clínica
 */
export function formatDateBR(utcDate: string | Date, timeZone: string): string {
  if (!utcDate) return ''

  const zonedDate = utcToZonedTime(utcDate, timeZone)

  return format(zonedDate, 'dd/MM/yyyy', { locale: locale })
}

/**
 * Formata hora UTC para HH:mm no timezone da clínica
 */
export function formatHour(utcDate: string | Date, timeZone: string): string {
  if (!utcDate) return ''

  const zonedDate = utcToZonedTime(utcDate, timeZone)

  return format(zonedDate, 'HH:mm', { locale: locale })
}

export function formatDateBRFull(
  utcDate: string | Date,
  timeZone: string
): string {
  if (!utcDate) return ''

  const zonedDate = utcToZonedTime(utcDate, timeZone)

  return format(zonedDate, "EEEE, dd 'de' MMMM", { locale: locale })
}

export function formatToDateInput(
  utcDate: string | Date,
  timeZone: string
): string {
  if (!utcDate) return ''

  const zonedDate = utcToZonedTime(utcDate, timeZone)

  return format(zonedDate, 'yyyy-MM-dd', { locale: locale })
}

export function formatToDateTimeInput(
  utcDate: string | Date,
  timezone: string
): string {
  if (!utcDate) return ''

  const zonedDate = utcToZonedTime(utcDate, timezone)

  return format(zonedDate, 'yyyy-MM-dd HH:mm')
}

/**
 * Formata data e hora completa (opcional - útil)
 */
export function formatDateTime(
  utcDate: string | Date,
  timeZone: string
): string {
  if (!utcDate) return ''

  const zonedDate = utcToZonedTime(utcDate, timeZone)

  return format(zonedDate, 'dd/MM/yyyy HH:mm', { locale })
}

/**
 * Converte data + hora LOCAL da clínica para UTC (para salvar no backend)
 *
 * @param date "2026-03-31"
 * @param time "10:00"
 * @param timeZone "Europe/Lisbon"
 */
export function toUtcFromClinic(
  date: string,
  time: string,
  timeZone: string
): string {
  if (!date || !time) return ''

  // junta data + hora como se fosse local da clínica
  const dateTimeString = `${date}T${time}:00`

  // converte de timezone da clínica para UTC
  const utcDate = zonedTimeToUtc(dateTimeString, timeZone)

  return utcDate.toISOString()
}
